import { UserTitle } from "@main/users/user-title";
import { IEpisode } from "@project/models/episodes/episode";
import { IEpisode_Diagnosis } from "../../models/episodes/episode_diagnosis";
import { EpisodeStatus } from "@project/models/episodes/episode-status";
import { GenericDiagnosisCodes } from "@project/diagnosis/generic-codes";

const emptyEpisode: IEpisode = {
    id: undefined,
    private: false,
    state: 0,
    userId: null,
    createDateTime: undefined,
    updateDateTime: undefined,
    diagnoses: [],
    defaultRoutineEpisode: false,
    notes: [],
    documents: [],
    prescriptions: [],
    formInstances:[],
    organizationId: "",
    organizationName: "",
    userFullName: "",
    userRole: "",
    userTitle: UserTitle.Mr,
    modifiedUserId: null,
    modifiedUserFullName: "",
    modifiedUserRole: "",
    modifiedUserTitle: UserTitle.Mr,
    assignedClinicianUserId: null,
    assignedClinicianUserRole: "",
    assignedClinicianUserFullName: "",
    assignedClinicianUserTitle: UserTitle.Mr,
    patientUserId: "",
    walkInClinicianId: "",
    ravenIssueId: null,
    ravenIssue: null,
    historical: [],
    isMasterEpisode: false,
    fromGrantedOrganizationAccess: false,
    alwaysActive: false,
    significant: false,
    isInactive: false,
    isLocked: false,
    defaultSelfDirectedGymRecoveryEpisode: false,
    isGenericEpisodeWithLimitedAccess: false,
    createFrom : 0,
    im1: false
};

export function createGenericPrescriptionEpisode(patientUserId?: string) {
    return <IEpisode>{
        ...emptyEpisode,
        patientUserId,
        state: EpisodeStatus.DraftPrescription,
        diagnoses: [
            <IEpisode_Diagnosis>{
                diagnosisCode: GenericDiagnosisCodes.GenericPrescriptionDiagnosisCode,
                diagnosisName: GenericDiagnosisCodes.GenericPrescriptionDiagnosisName,
                diagnosisBodyPartName: "N/A",
                bodySide: "N/A"
            }
        ]
    };
}

export function createRoutineTreatmentEpisode(patientUserId?: string) {
    return <IEpisode>{
        ...emptyEpisode,
        patientUserId,
        diagnoses: [
            <IEpisode_Diagnosis>{
                diagnosisCode: GenericDiagnosisCodes.RoutineDiagnosisCode,
                diagnosisName: GenericDiagnosisCodes.RoutineDiagnosisName,
                diagnosisBodyPartName: "N/A"
            }
        ]
    };
}

export function createSelfDirectedGymRecoveryEpisode(patientUserId?: string) {
    return <IEpisode>{
        ...emptyEpisode,
        patientUserId,
        diagnoses: [
            <IEpisode_Diagnosis>{
                diagnosisCode: GenericDiagnosisCodes.GymRecoveryDiagnosisCode,
                diagnosisName: GenericDiagnosisCodes.GymRecoveryDiagnosisName,
                bodySide: "N/A",
                diagnosisBodyPartName: "N/A"
            }
        ]
    };
}

export function isGenericPrescriptionEpisode(episode: IEpisode) {
    return (
        episode?.diagnoses?.length === 1 && episode.diagnoses[0].diagnosisCode === GenericDiagnosisCodes.GenericPrescriptionDiagnosisCode
    );
}

export function isRoutineTreatmentEpisode(episode: IEpisode) {
    return episode?.diagnoses?.length === 1 && episode.diagnoses[0].diagnosisCode === GenericDiagnosisCodes.RoutineDiagnosisCode;
}

export function isSelfDirectedGymRecoveryEpisode(episode: IEpisode) {
    return episode?.diagnoses?.length === 1 && episode.diagnoses[0].diagnosisCode === GenericDiagnosisCodes.GymRecoveryDiagnosisCode;
}

export function isNoteDraftEpisode(episode: IEpisode) {
    return episode?.diagnoses?.length === 1 && episode.diagnoses[0].diagnosisCode === GenericDiagnosisCodes.NoteDraftCode;
}




